import { CountryFlagWithName } from 'entities/country';
import { CountryTableColumns } from './CountryTable.types';
import { ColumnTitle } from './ui/ColumnTitle';

const COLSPAN_FULL = 5;
export const COLSPAN_HIDDEN = 0;
export const HEADER_HEIGHT = 48;
export const BORDER_HEIGHT = 1;

export const columns: CountryTableColumns[] = [
  {
    title: <ColumnTitle title="Country:CountryTable.columns.name.title" />,
    dataIndex: 'nameWithFlag',
    width: '25%',
    sorter: true,
    onCell: (data) => {
      return 'children' in data ? { colSpan: COLSPAN_FULL } : {};
    },
    render: (record) => {
      if (!record) return null;

      return <CountryFlagWithName name={record.name} flagUrl={record.flagUrl} />;
    },
  },
  {
    title: <ColumnTitle title="Country:CountryTable.columns.localName.title" />,
    dataIndex: 'localName',
    width: '25%',
    onCell: (data) => {
      return 'children' in data ? { colSpan: COLSPAN_FULL } : {};
    },
  },
  {
    title: <ColumnTitle title="Country:CountryTable.columns.twoLetterCode.title" />,
    dataIndex: 'iso2',
    width: '25%',
    onCell: (data) => {
      return 'children' in data ? { colSpan: COLSPAN_FULL } : {};
    },
  },
  {
    title: <ColumnTitle title="Country:CountryTable.columns.threeLetterCode.title" />,
    dataIndex: 'iso3',
    width: '25%',
    onCell: (data) => {
      return 'children' in data ? { colSpan: COLSPAN_FULL } : {};
    },
  },
];
